import * as React from 'react';
import PropTypes from 'prop-types';
import Typography from '@mui/material/Typography';

function SubTitle(props) {
  return (
    <Typography component="h3" variant="subtitle1" color="black" gutterBottom>
      {props.children}
    </Typography>
  );
}

SubTitle.propTypes = {
  children: PropTypes.node,
};

export default SubTitle;